// extracted by mini-css-extract-plugin
var _1 = "AnswerFeedback_content__b56c0";
var _2 = "AnswerFeedback_image__0b06c";
var _3 = "AnswerFeedback_root__a073c";
export { _1 as "content", _2 as "image", _3 as "root" }
